import { createReducer, createActions } from 'reduxsauce';
import { getCurrentMonth, getCurrentYear } from '@utils/date';
import { CLEANS_STAGE, CLEANS_LIST_TYPE, ALL_PROPETY } from '@services/minte';

const { Types, Creators } = createActions({
  setMyCleansOfMonthLoadRequest: ['month', 'year'],
  setMyCleansLoadRequest: null,
  setMyCleanDetailLoadRequest: ['bookingId', 'searchParams'],
  setMyCleanDetailUpdateRequest: ['bookingId', 'data'],
  setMyCleansLoading: ['loading'],
  setMyCleansListLoading: ['listLoading'],
  setMyCleansError: ['error'],
  setMyCleansOfMonth: ['cleans', 'month', 'year'],
  setMyCleansList: ['list'],
  setCurrentClean: ['clean'],
  setMyCleansCurrentView: ['view'],
  setMyCleansHomeView: ['view'],
  setCurrentCleanEditing: ['step', 'editData'],
  setMyCleansHomeViewProperty: ['property']
});

export const CleansTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  currentView: CLEANS_STAGE.HOME,
  loaded: false,
  loading: false,
  listLoaded: false,
  listLoading: false,
  error: null,
  cleans: [],
  list: [],
  currentMonth: getCurrentMonth(),
  currentYear: getCurrentYear(),
  currentClean: null,
  currentPropertyId: '',
  homeView: 'Services',
  cleanEditing: null,
  editData: null,
  property: ALL_PROPETY
};

const filterCurrentProperty = (arr, property) => {
  if (!property || property.propertyID === 0) {
    return arr;
  }

  return arr.filter(item => item.propertyID === property.propertyID);
};

/* ------- Selectors --------- */
export const CleansSelectors = {
  selectView: state => state.myCleans.currentView,
  selectLoading: state => state.myCleans.loading,
  selectHomeView: state => state.myCleans.homeView,
  selectHomeViewProperty: state => state.myCleans.property,
  selectCurrentClean: state => state.myCleans.currentClean,
  selectCurrentMonth: state => state.myCleans.currentMonth,
  selectCurrentYear: state => state.myCleans.currentYear,
  selectCleanEditing: state => state.myCleans.cleanEditing,
  selectCleanEditData: state => state.myCleans.editData,
  selectCleansOfMonth: state =>
    filterCurrentProperty(state.myCleans.cleans, state.myCleans.property),
  selectCleansList: (state, type) => {
    const filteredItems = filterCurrentProperty(
      state.myCleans.list,
      state.myCleans.property
    );
    if (type === CLEANS_LIST_TYPE.FUTURE) {
      const list = filteredItems.filter(
        item => item.status !== 'canceled' && item.status !== 'cleaned'
      );
      list.sort((a, b) => a.serviceDateTimestamp - b.serviceDateTimestamp);
      return list;
    } else if (type === CLEANS_LIST_TYPE.PAST) {
      const list = filteredItems.filter(item => item.status === 'cleaned');
      list.sort((a, b) => b.serviceDateTimestamp - a.serviceDateTimestamp);
      return list.slice(0, 5);
    }
    return filteredItems;
  },
  isRecurringClean: state =>
    state.myCleans.currentClean && state.myCleans.currentClean.isRecurring
};

/* -------- Reducers ---------- */
export const setLoading = (state, { loading }) => ({
  ...state,
  loading
});

export const setListLoading = (state, { listLoading }) => ({
  ...state,
  listLoading
});

export const setError = (state, { error }) => ({
  ...state,
  error
});

export const setCleansOfMonth = (state, { cleans, month, year }) => ({
  ...state,
  cleans,
  currentMonth: month,
  currentYear: year,
  loaded: true
});

export const setMyCleansList = (state, { list }) => ({
  ...state,
  list,
  listLoaded: true
});

export const setCurrentClean = (state, { clean }) => ({
  ...state,
  currentClean: clean
});

export const setMyCleansHomeViewProperty = (state, { property }) => {
  return {
    ...state,
    property
  };
};

export const setCurrentView = (state, { view }) => ({
  ...state,
  currentView: view
});

export const setHomeView = (state, { view }) => ({
  ...state,
  homeView: view
});

export const setCleanEditing = (state, { step, editData }) => ({
  ...state,
  cleanEditing: step,
  editData
});

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_MY_CLEANS_LOADING]: setLoading,
  [Types.SET_MY_CLEANS_LIST_LOADING]: setListLoading,
  [Types.SET_MY_CLEANS_ERROR]: setError,
  [Types.SET_MY_CLEANS_LIST]: setMyCleansList,
  [Types.SET_MY_CLEANS_OF_MONTH]: setCleansOfMonth,
  [Types.SET_MY_CLEANS_CURRENT_VIEW]: setCurrentView,
  [Types.SET_MY_CLEANS_HOME_VIEW]: setHomeView,
  [Types.SET_CURRENT_CLEAN]: setCurrentClean,
  [Types.SET_CURRENT_CLEAN_EDITING]: setCleanEditing,
  [Types.SET_MY_CLEANS_HOME_VIEW_PROPERTY]: setMyCleansHomeViewProperty
});
